import React from 'react';

const split = (template: string, placeholderNames: string[]) => {
    const placeholders = placeholderNames
        .map(placeholderName => ({
            name: placeholderName,
            index: template.indexOf(placeholderName),
        }))
        .filter(({ index }) => index !== -1)
        .sort((a, b) => a.index - b.index);

    if (placeholders.length) {
        const segments = [template.slice(0, placeholders[0].index)];
        const lastIndex = placeholders.length - 1;
        for (let i = 0; i < placeholders.length; i++) {
            segments.push(placeholders[i].name);
            if (i !== lastIndex) {
                segments.push(
                    template.slice(
                        placeholders[i].index + placeholders[i].name.length,
                        placeholders[i + 1].index,
                    ),
                );
            }
        }
        segments.push(
            template.slice(
                placeholders[lastIndex].index + placeholders[lastIndex].name.length,
                template.length,
            ),
        );
        return segments;
    } else {
        return [template];
    }
};

const placeholderReplace = <T extends string = string>(
    template: string,
    replacer: { [P in T]: (placeholder: P) => React.ReactNode },
    defaultReplacer?: (segment: string) => React.ReactNode,
) => {
    const placeholderNames = Object.keys(replacer);
    return (
        <>
            {split(template, placeholderNames).map(segment => {
                if (!segment) return null;

                if (placeholderNames.includes(segment)) {
                    return replacer[segment as T](segment as T);
                }
                return typeof defaultReplacer === 'function' ? defaultReplacer(segment) : segment;
            })}
        </>
    );
};

export default placeholderReplace;
